const steps = ['Cliente', 'Móveis', 'Resumo']

export function ProgressBar({ current }) {
  return (
    <div className="flex items-center gap-0">
      {steps.map((label, i) => {
        const idx    = i + 1
        const done   = idx < current
        const active = idx === current

        return (
          <div key={label} className="flex items-center flex-1 last:flex-none">
            <div className="flex flex-col items-center">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-all
                  ${done   ? 'bg-[#111111] text-[#F5C200]'                          : ''}
                  ${active ? 'bg-[#F5C200] text-[#111111] ring-4 ring-[#F5C200]/20' : ''}
                  ${!done && !active ? 'bg-slate-200 text-slate-400'          : ''}
                `}
              >
                {done ? '✓' : idx}
              </div>
              <span
                className={`mt-1 text-xs font-semibold whitespace-nowrap
                  ${active ? 'text-[#111111]'       : done ? 'text-slate-500' : 'text-slate-400'}
                `}
              >
                {label}
              </span>
            </div>
            {i < steps.length - 1 && (
              <div className={`flex-1 h-0.5 mx-2 mb-5 rounded ${done ? 'bg-[#111111]' : 'bg-slate-200'}`} />
            )}
          </div>
        )
      })}
    </div>
  )
}
